import { Breadcrumb } from '@components/common/breadcrumb';
import { withTheme } from '@emotion/react';
import React from 'react';
import { DestinationLinkBuilder, LinkItem, Name } from '@model/iceberg/geography';
import { useI18NextContext } from '@components/hooks';
import { Item } from '@components/breadcrumbs/item';
import { Page, TripTypes } from '@model/common';

export interface GuidesBreadcrumbProps {
  destination: Name;
  tripType?: TripTypes;
  guidePage: Page;
}

export const getGuideLabel = (guidePage: Page) => {
  switch (guidePage) {
    case Page.VIDEO_GUIDES:
      return 'video-guides__breadcrumb--label';
    case Page.TRAVEL_GUIDES:
      return 'travel-guides__breadcrumb--label';
    case Page.EXPERIENCES:
      return 'experiences__breadcrumb--label';
    default:
      return '';
  }
};

const GuidesBreadcrumbComponent = ({ destination: { path, display }, tripType, guidePage }: GuidesBreadcrumbProps) => {
  const t: any = useI18NextContext();

  const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const destinationLink: LinkItem = builder.getDestinationLink(path, tripType);
  const guidesLink: LinkItem = builder.getGuidesLink(path, guidePage, tripType);
  const items: Array<Item> = [
    { ...destinationLink, display },
    { ...guidesLink, display: t(getGuideLabel(guidePage)) }
  ];
  return <Breadcrumb items={items} tripType={tripType} />;
};

export const GuidesBreadcrumb = withTheme(GuidesBreadcrumbComponent);
